import angular from 'angular';
import './appsServices';
import './appsDirectives';

/**
 * @ngdoc overview
 * @name adminModule.appsControllers
 * @description
 * # adminModule.appsControllers
 */
var appsControllers = angular.module('adminModule.appsControllers', ['adminModule.appsDirectives', 'adminModule.appsServices']);

(function () {
    'use strict';
    /**
     * @ngdoc controller
     * @name adminModule.appsControllers.controller:AppsListController
     * @description
     * Controller for the list of Apps/SDKs page
     */
    appsControllers.controller('AppsListController', ['$scope', '$rootScope', '$state', 'growl', 'NgTableParams', '$modal', 'App', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, growl, NgTableParams, $modal, App, AppsoupAPI, Permissions) {
        $scope.search = {};
        $scope.writeAccess = Permissions.hasWriteAccess('application');
        $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
            getData: function (params) {
                $scope.isLoading = true;
                return App.getList(params && params._params ? params._params : {})
                    .then(function (response) {
                        if (angular.isDefined(response)) {
                            var applications = response.applications;
                            $scope.systems = response.systems;
                            // update table params
                            params.total(applications.total);
                            params.count(applications.per_page);
                            params.page(applications.current_page);
                            // set new data
                            return applications.data;
                        }
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                    });
            },
            counts: AppsoupAPI.getDefaultCounts()
        });
        $scope.newApp = function () {
            var modalInstance = $modal.open({
                templateUrl: 'views/admin/apps/components/modal/app.tpl.html',
                controller: 'AppModalController',
                resolve: {
                    app: function () {
                        return {
                            superadmin: Permissions.hasSuperAdminAccess()
                        };
                    }
                }
            });
            modalInstance.result.then(function () {
                growl.success('MODULES.APPLICATIONS.SUCCESS.APP_CREATED');
                // dodanie apki
                $rootScope.$broadcast('newApp');
                $state.go($state.current, {}, {reload: true});
            }).catch(() => {});
        };

        $scope.deleteApp = function (app_id) {
            $scope.isLoading = true;
            App.remove(app_id)
                .then(function (response) {
                    var data = response.data;
                    if (data.success) {
                        growl.success('MODULES.APPLICATIONS.SUCCESS.APP_DELETED');
                        $state.go($state.current, {}, {reload: true});
                    } else if (data.error) {
                        growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };

        $scope.searchApps = function (search) {
            $scope.isFind = true;
            var find = angular.copy(search);
            angular.extend($scope.tableParams._params, find);
            $scope.isFind = false;
        };
        $scope.clearSearch = function () {
            $scope.search = {};
            if (angular.isDefined($scope.tableParams._params.name)) {
                $scope.tableParams._params.name = undefined;
            }
        };

    }]);
    /**
     * @ngdoc controller
     * @name adminModule.appsControllers.controller:AppModalController
     * @description
     * Controller for new App modal
     */
    appsControllers.controller('AppModalController', ['$scope', '$state', '$rootScope', '$modalInstance', 'growl', 'App', 'Client', 'app', function ($scope, $state, $rootScope, $modalInstance, growl, App, Client, app) {
        $scope.app = {};
        $scope.showAdvanced = app.superadmin;
        if (angular.isDefined(app.name)) {
            $scope.editMode = true;
            $scope.app = angular.copy(app);
        }
        $scope.isLoadingList = true;
        App.getModuleTypes()
            .then(function (response) {
                var data = response.data;
                if (data.success) {
                    $scope.module_types = data.types;
                    $scope.web_modules = data.web_modules;
                    $scope.web_actions = data.web_actions;
                    $scope.web_sections = data.web_sections;
                    $scope.page_types = data.pages;
                    $scope.web_type_actions = data.web_type_actions;
                }
            })
            .finally(function () {
                $scope.isLoadingList = false;
            });

        var parseSelected = function (selected) {
            var data = [];
            for (var i = 0; i < selected.length; i++) {
                if (selected[i].selected) {
                    data.push(selected[i].id);
                }
            }

            return data;
        };

        $scope.ok = function () {
            $scope.$broadcast('show-errors-check-validity');
            if ($scope.appForm.$valid) {
                var data = {app: $scope.app};
                if (angular.isDefined($scope.client)) {
                    data.client = $scope.client.selected;
                }

                $scope.isLoading = true;
                if ($scope.editMode) {
                    // Prepare App object
                    var app = {
                        id: $scope.app.id,
                        name: $scope.app.name,
                        module_types: parseSelected(angular.copy($scope.module_types)),
                        web_sections: parseSelectedKeys(angular.copy($scope.web_sections)),
                        web_actions: parseSelectedKeys(angular.copy($scope.web_actions)),
                        web_modules: parseSelectedKeys(angular.copy($scope.web_modules)),
                        page_types: parseSelected(angular.copy($scope.page_types)),
                        web_type_actions: parseSelectedKeys(angular.copy($scope.web_type_actions))
                    };
                    App.save(app, $scope.editMode)
                        .then(function (response) {
                            var data = response.data;
                            if (data.success) {
                                $modalInstance.close(data.application);
                            } else {
                                growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_EDITED');
                            }
                        })
                        .finally(function () {
                            $scope.isLoading = false;
                        });
                } else {
                    $scope.app.module_types = parseSelected(angular.copy($scope.module_types));
                    $scope.app.web_sections = parseSelectedKeys(angular.copy($scope.web_sections));
                    $scope.app.web_modules = parseSelectedKeys(angular.copy($scope.web_modules));
                    $scope.app.web_actions = parseSelectedKeys(angular.copy($scope.web_actions));
                    $scope.app.page_types = parseSelected(angular.copy($scope.page_types));
                    $scope.app.web_type_actions = parseSelectedKeys(angular.copy($scope.web_type_actions));
                    App.save($scope.app)
                        .then(function (response) {
                            var data = response.data;
                            if (data.success) {
                                $modalInstance.close(data);
                            } else {
                                if (typeof data.error === 'object') {
                                    $scope.formErrors = data.error;
                                } else {
                                    growl.error('MODULES.APPLICATIONS.ERROR.APP_CREATED');
                                }
                            }
                        })
                        .finally(function () {
                            $scope.isLoading = false;
                        });
                }
            }
        };
        var parseSelectedKeys = function (selected, reversed, reverse) {
            var i;
            if (angular.isUndefined(reversed)) {
                var data = [];
                for (i = 0; i < selected.length; i++) {
                    if (selected[i].selected) {
                        data.push(selected[i].key);
                    }
                }

                return data;
            }
            if (reverse && reverse !== null) {
                for (i = 0; i < selected.length; i++) {
                    if (reverse.indexOf(selected[i].key) !== -1) {
                        selected[i].selected = true;
                    }
                }
            }

            return selected;
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.remove = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.deleteApp = function () {
            $scope.isLoading = true;
            App.remove($scope.app.id)
                .then(function (response) {
                    var data = response.data;
                    if (data.success) {
                        growl.success('MODULES.APPLICATIONS.SUCCESS.APP_DELETED');
                        $state.go('appsoup.admin.apps');
                    } else if (data.error) {
                        growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };
        $scope.inputErrors = {
            'appName': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.ERROR.REQUIRE.APP_NAME'}],
            'newPassword': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.ERROR.REQUIRE.PASSWORD'}],
            'email': [{error: 'required', msg: 'ERROR.REQUIRE.EMAIL'}, {error: 'email', msg: 'ERROR.INVALID_EMAIL'}]
        };
    }]);
    appsControllers.controller('PageModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Page', 'Client', 'page', function ($scope, $state, $stateParams, $modalInstance, growl, Page, Client, page) {
        $scope.page = {};
        $scope.showAdvanced = page.superadmin;
        if (page.name) {
            $scope.editMode = true;
            $scope.page = angular.copy(page);
        }
        $scope.ok = function () {
            $scope.$broadcast('show-errors-check-validity');
            var appId = $stateParams.appId;
            $scope.page.application_id = appId;
            $scope.isLoading = true;
            if ($scope.editMode) {
                // Prepare App object
                /* eslint-disable */
                var page = {
                    id: $scope.page.id,
                    name: $scope.page.name
                };
                /* eslint-enable */
            }
            Page.save($scope.page, $scope.editMode)
                .then(function (response) {
                    var data = response.data;
                    if (data.success) {
                        $modalInstance.close(data);
                    } else {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error('MODULES.APPLICATIONS.ERROR.APP_CREATED');
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.remove = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.deletePage = function () {
            $scope.isLoading = true;
            Page.remove($scope.page.id)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.APPLICATIONS.SUCCESS.PAGE_DELETED');
                        $modalInstance.close(data.page);
                        $state.reload();
                    } else if (data.error) {
                        growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };
        $scope.inputErrors = {
            'appName': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.ERROR.REQUIRE.APP_NAME'}],
            'newPassword': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.ERROR.REQUIRE.PASSWORD'}]
        };
    }]);
    appsControllers.controller('ModuleModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Module', 'Client', 'module', function ($scope, $state, $stateParams, $modalInstance, growl, Module, Client, module) {
        $scope.module = {};
        $scope.showAdvanced = module.superadmin;
        $scope.module.page_id = module.page_id;
        Module.getModalData().then(function (result) {
            let data = result.data;

            $scope.templates = data.templates;
            $scope.module_types = data.types;
        });
        if (module.name) {
            $scope.editMode = true;
            $scope.module = angular.copy(module);
        }
        $scope.ok = function () {
            $scope.$broadcast('show-errors-check-validity');
            $scope.isLoading = true;
            var module = $scope.module;
            if ($scope.editMode) {
                // Prepare App object
                module = {
                    id: $scope.module.id,
                    name: $scope.module.name,
                    module_type: parseInt($scope.module.module_type),
                    template: parseInt($scope.module.template),
                    page_id: $scope.module.page_id
                };
            }
            Module.save(module, $scope.editMode)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        $modalInstance.close(data);
                    } else {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error('MODULES.APPLICATIONS.ERROR.APP_CREATED');
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.remove = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.deleteModule = function () {
            $scope.isLoading = true;
            Module.remove($scope.module.id)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_DELETED');
                        $modalInstance.close(data.module);
                        $state.reload();
                    } else if (data.error) {
                        growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };
        $scope.inputErrors = {
            'appName': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.ERROR.REQUIRE.APP_NAME'}]
        };
    }]);
    appsControllers.controller('ModuleElementModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'ModuleElement', 'Client', 'module_element', 'pages', function ($scope, $state, $stateParams, $modalInstance, growl, ModuleElement, Client, module_element, pages) {
        $scope.pages = pages;
        $scope.module_element = {
            module_id: module_element.module_id,
            external: 0
        };
        $scope.upload = undefined;
        $scope.editMode = false;
        if (module_element.name) {
            $scope.editMode = true;
            $scope.fileUploaded = true;
            $scope.module_element = angular.copy(module_element);
        }

        $scope.uploadSuccess = function (file) {
            $scope.upload = file;
            $scope.fileUploaded = true;
            $scope.fileError = false;
            $scope.$apply();
        };
        $scope.removeFile = function () {
            $scope.upload = undefined;
            $scope.fileUploaded = false;
            $scope.showMap = false;
        };
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.ok = function () {
            $scope.$broadcast('show-errors-check-validity');
            $scope.fileError = angular.isNullOrUndefined($scope.upload) && angular.isNullOrUndefined($scope.module_element.file);
            if (!$scope.fileError) {
                $scope.isLoading = true;
                var module_element = $scope.module_element;
                if ($scope.editMode) {
                    // Prepare App object
                    module_element = {
                        id: $scope.module_element.id,
                        name: $scope.module_element.name,
                        external: $scope.module_element.external,
                        external_link: $scope.module_element.external_link,
                        internal_link: $scope.module_element.internal_link
                    };
                }
                ModuleElement.save(module_element, $scope.editMode, $scope.upload)
                    .then(function (result) {
                        let data = result.data;

                        if (data.success) {
                            $modalInstance.close(data);
                            $scope.fileError = false;
                        } else {
                            if (typeof data.error === 'object') {
                                $scope.formErrors = data.error;
                            } else {
                                growl.error('MODULES.APPLICATIONS.ERROR.APP_CREATED');
                            }
                        }
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                    });
            }
        };
    }]);
    /**
     * @ngdoc controller
     * @name adminModule.appsControllers.controller:AppPageController
     * @description
     * Controller for specific Application page
     */
    appsControllers.controller('AppPageController', ['$scope', '$http', '$rootScope', '$state', '$modal', '$stateParams', 'growl', 'Page', 'App', 'Permissions', function ($scope, $http, $rootScope, $state, $modal, $stateParams, growl, Page, App, Permissions) {
        var appId = $stateParams.appId;
        $scope.writeAccess = Permissions.hasWriteAccess('application');
        $scope.showAdvanced = Permissions.hasSuperAdminAccess();
        $rootScope.doingResolve = true;
        Page.getList(appId).then(function (response) {
            if (response.data.success) {
                $scope.pages = response.data.pages;
            } else {
                $scope.pages = 'Brak wyników';
            }
        });
        App.getForm()
            .then(function (response) {
                var data = response.data;
                if (data.success) {
                    $scope.packages = data.packages;
                    if (angular.isDefined(appId)) {
                        $scope.editMode = true;

                        return App.get(appId);
                    } else {
                        $scope.app = {
                            system: Object.keys($scope.packages)[0]
                        };
                    }
                }
            })
            .then(function (response) {
                if (angular.isDefined(response)) {
                    var data = response.data;
                    $scope.app = data.application;
                    $scope.app.password = '';
                    $scope.test = 'test1';
                    $scope.appName = $scope.app.name;
                    $scope.isLoadingList = true;
                    App.getModuleTypes()
                        .then(function (response) {
                            var data = response.data;
                            if (data.success) {
                                $scope.module_types = parseSelected(data.types, true, angular.copy($scope.app.module_types));
                                $scope.page_types = parseSelected(data.pages, true, angular.copy($scope.app.page_types));
                                $scope.web_sections = parseSelectedKeys(data.web_sections, true, angular.copy($scope.app.web_sections));
                                $scope.web_modules = parseSelectedKeys(data.web_modules, true, angular.copy($scope.app.web_modules));
                                $scope.web_actions = parseSelectedKeys(data.web_actions, true, angular.copy($scope.app.web_actions));
                                $scope.web_type_actions = parseSelectedKeys(data.web_type_actions, true, angular.copy($scope.app.web_type_actions));
                            }
                        })
                        .finally(function () {
                            $scope.isLoadingList = false;
                        });
                }
            })
            .finally($rootScope.doneLoading);

        var parseSelected = function (selected, reversed, reverse) {
            var i;
            if (angular.isUndefined(reversed)) {
                var data = [];
                for (i = 0; i < selected.length; i++) {
                    if (selected[i].selected) {
                        data.push(selected[i].id);
                    }
                }

                return data;
            }
            if (reverse && reverse !== null) {
                for (i = 0; i < selected.length; i++) {
                    if (reverse.indexOf(selected[i].id) !== -1) {
                        selected[i].selected = true;
                    }
                }
            }

            return selected;
        };

        var parseSelectedKeys = function (selected, reversed, reverse) {
            if (angular.isUndefined(reversed)) {
                var data = [];
                for (var i = 0; i < selected.length; i++) {
                    if (selected[i].selected) {
                        data.push(selected[i].key);
                    }
                }

                return data;
            }
            if (reverse && reverse !== null) {
                for (var j = 0; j < selected.length; j++) {
                    if (reverse.indexOf(selected[j].key) !== -1) {
                        selected[j].selected = true;
                    }
                }
            }

            return selected;
        };

        $scope.saveApp = function () {
            $scope.$broadcast('show-errors-check-validity');
            if ($scope.appForm.$valid) {
                $scope.isLoading = true;
                $scope.app.module_types = parseSelected(angular.copy($scope.module_types));
                $scope.app.page_types = parseSelected(angular.copy($scope.page_types));
                $scope.app.web_sections = parseSelectedKeys(angular.copy($scope.web_sections));
                $scope.app.web_modules = parseSelectedKeys(angular.copy($scope.web_modules));
                $scope.app.web_actions = parseSelectedKeys(angular.copy($scope.web_actions));
                $scope.app.web_type_actions = parseSelectedKeys(angular.copy($scope.web_type_actions));
                App.save($scope.app, $scope.editMode)
                    .then(function (response) {
                        var data = response.data;
                        if (data.success) {
                            growl.success('MODULES.APPS.SUCCESS.' + ($scope.editMode ? 'EDIT' : 'NEW'));
                            $state.go('appsoup.admin.apps');
                        } else if (data.error) {
                            if (typeof data.error === 'object') {
                                $scope.formErrors = data.error;
                            } else {
                                growl.error(data.error);
                            }
                        }
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                    });
            }
        };
        $scope.deleteApp = function () {
            if (angular.isDefined($scope.app.id)) {
                $scope.isLoading = true;
                App.remove($scope.app.id)
                    .then(function (result) {
                        let data = result.data;

                        if (data.success) {
                            $rootScope.$broadcast('newApp');
                            growl.success('MODULES.APPS.SUCCESS.DELETE');
                            $state.go('appsoup.admin.apps');
                        } else if (data.error) {
                            $scope.formErrors = data.error;
                        }
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                    });
            }
        };
        $scope.cancel = function () {
            $state.go('appsoup.admin.apps');
        };
        $scope.inputErrors = {
            'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}],
            'id': [{type: '$invalid', msg: 'ERROR.REQUIRE.ID'}],
            'email': [{error: 'required', msg: 'ERROR.REQUIRE.EMAIL'}, {error: 'email', msg: 'ERROR.INVALID_EMAIL'}]
        };
        $scope.addPageAction = function () {
            var modalInstance = $modal.open({
                templateUrl: 'views/admin/apps/components/modal/page.tpl.html',
                controller: 'PageModalController',
                resolve: {
                    page: function () {
                        return {
                            superadmin: Permissions.hasSuperAdminAccess()
                        };
                    }
                }
            });
            modalInstance.result.then(function (data) {
                $scope.newPage = {
                    id: data.page.id,
                    name: data.page.name,
                    application_id: data.page.application_id,
                    children: [],
                    showChildren: false,
                    child_type: 'module',
                    type: 'page'
                };
                $scope.pages.push($scope.newPage);
                growl.success('MODULES.APPLICATIONS.SUCCESS.PAGE_CREATED');
            }).catch(() => {});
        };

        $scope.addModuleAction = function (page) {
            $scope.module = {page_id: page.id};
            var modalInstance = $modal.open({
                templateUrl: 'views/admin/apps/components/modal/module.tpl.html',
                controller: 'ModuleModalController',
                resolve: {
                    module: function () {
                        return angular.extend($scope.module, {superadmin: Permissions.hasSuperAdminAccess()});
                    }
                }
            });
            modalInstance.result.then(function (data) {
                $scope.newModule = {
                    id: data.module.id,
                    name: data.module.name,
                    module_type: parseInt(data.module.module_type),
                    template: data.module.template,
                    page_id: data.module.page_id,
                    children: [],
                    showChildren: false,
                    child_type: 'module_element',
                    type: 'module'
                };
                page.children.push($scope.newModule);
                growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_CREATED');
            }).catch(() => {});
        };
        $scope.addModuleElementAction = function (module) {
            $scope.module_element = {module_id: module.id};
            var modalInstance = $modal.open({
                templateUrl: 'views/admin/apps/components/modal/module_element.tpl.html',
                controller: 'ModuleElementModalController',
                resolve: {
                    module_element: function () {
                        return angular.extend($scope.module_element, {superadmin: Permissions.hasSuperAdminAccess()});
                    },
                    pages: function () {
                        return $scope.pages;
                    }
                }
            });
            modalInstance.result.then(function (data) {
                var moduleElement = {
                    id: data.moduleElement.id,
                    name: data.moduleElement.name,
                    external: parseInt(data.moduleElement.external),
                    file: data.moduleElement.file,
                    module_id: data.moduleElement.module_id,
                    page_id: data.moduleElement.page_id,
                    type: 'module_element'
                };
                if (moduleElement.external) {
                    moduleElement.internal_link = parseInt(data.moduleElement.internal_link);
                } else {
                    moduleElement.external_link = data.moduleElement.external_link;
                }

                module.children.push(moduleElement);
                growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_ELEMENT_CREATED');
            }).catch(() => {});
        };

        $scope.editModuleElementAction = function ($event, module_element) {
            $event.stopImmediatePropagation();
            $scope.module_element = module_element;
            var modalInstance = $modal.open({
                templateUrl: 'views/admin/apps/components/modal/module_element.tpl.html',
                controller: 'ModuleElementModalController',
                resolve: {
                    module_element: function () {
                        return angular.extend($scope.module_element, {superadmin: Permissions.hasSuperAdminAccess()});
                    },
                    pages: function () {
                        return $scope.pages;
                    }
                }
            });
            modalInstance.result.then(function (data) {
                var moduleElement = {
                    id: data.moduleElement.id,
                    name: data.moduleElement.name,
                    external: parseInt(data.moduleElement.external),
                    file: data.moduleElement.file,
                    module_id: data.moduleElement.module_id,
                    type: 'module_element'
                };
                if (moduleElement.external) {
                    moduleElement.internal_link = parseInt(data.moduleElement.internal_link);
                } else {
                    moduleElement.external_link = data.moduleElement.external_link;
                }
                var pageKey = 0;
                angular.forEach($scope.pages, function (page, key) {
                    if (page.id === data.moduleElement.page_id) {
                        pageKey = key;
                    }
                });
                var moduleKey = 0;
                angular.forEach($scope.pages[pageKey].children, function (module, key) {
                    if (module.id === data.moduleElement.module_id) {
                        moduleKey = key;
                    }
                });
                angular.forEach($scope.pages[pageKey].children[moduleKey].children, function (element, key) {
                    if (element.id === data.moduleElement.id) {
                        elementKey = key;
                    }
                });
                var elementKey = 0;
                $scope.pages[pageKey].children[moduleKey].children[elementKey] = moduleElement;
                growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_ELEMENT_EDITED');
            }).catch(() => {});
        };

        $scope.editApp = function () {
            var modalInstance = $modal.open({
                templateUrl: 'views/admin/apps/components/modal/app.tpl.html',
                controller: 'AppModalController',
                resolve: {
                    app: function () {
                        return angular.extend($scope.app, {superadmin: Permissions.hasSuperAdminAccess()});
                    }
                }
            });
            modalInstance.result.then(function (data) {
                growl.success('MODULES.APPLICATIONS.SUCCESS.APP_EDITED');
                angular.extend($scope.app, data);
            }).catch(() => {});
        };
    }]);
    /**
     * @ngdoc controller
     * @name adminModule.appsControllers.controller:AppAttributeController
     * @description
     * Controller For Application Attributes
     */
    appsControllers.controller('AppAttributeController', ['$scope', '$http', '$rootScope', '$state', '$modal', '$stateParams', 'growl', 'Page', 'App', 'Permissions', '$filter', function ($scope, $http, $rootScope, $state, $modal, $stateParams, growl, Page, App, Permissions, $filter) {
        const appId = $stateParams.appId;
        $scope.writeAccess = Permissions.hasWriteAccess('application');
        $scope.showAdvanced = Permissions.hasSuperAdminAccess();

        $scope.attribute = {};
        $scope.editMode = false;
        $scope.isLoading = true;
        $scope.elements = [];

        if (appId) {
            App.get(appId).then(function (response) {
                var data = response.data;
                if (data.success) {
                    $scope.app = data.application;
                    $scope.attributeKey = $stateParams.key;
                    $scope.attributeModule = $stateParams.module;
                    if (angular.isDefined($scope.attributeModule)) {
                        $scope.attributes = ($scope.app.module_attributes !== null && angular.isDefined($scope.app.module_attributes[$scope.attributeModule])) ? $scope.app.module_attributes[$scope.attributeModule] : [];
                        if (angular.isDefined($scope.attributeKey)) {
                            $scope.editMode = true;
                            if ($scope.attributeModule === 'product') {
                                $scope.attribute = $scope.attributes[$scope.attributeKey];
                            } else {
                                $scope.attribute = $scope.app[$scope.attributeModule + '_attributes'][$scope.attributeKey];
                            }
                        }
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        } else {
            $state.go('appsoup.admin.apps');
        }

        App.getAttributeTypes().then(function (response) {
            var data = response.data;
            if (data.success) {
                $scope.attribute_types = data.types;
            }
        });

        $scope.searchElements = function (text) {
            $scope.elements = [];
            text = $filter('removeSpecial')(text);
            if ($scope.elements.indexOf(text) < 0) {
                $scope.elements.push(text);
            }
        };

        $scope.deleteAttribute = function (app_id, attr_key, module) {
            $scope.isLoading = true;
            App.removeAttribute(app_id, attr_key, module).then(function (response) {
                var data = response.data;
                if (data.success) {
                    growl.success('MODULES.ATTRIBUTES.SUCCESS.DELETE');
                    $state.go($state.current, {}, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.ATTRIBUTES.ERROR.DELETE');
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        };

        $scope.saveAttribute = function () {
            $scope.$broadcast('show-errors-check-validity');
            if ($scope.attrForm.$valid) {
                $scope.isLoading = true;
                App.saveAttribute($scope.app.id, $scope.attributeModule, $scope.editMode, $scope.attribute).then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        growl.success('MODULES.ATTRIBUTES.SUCCESS.' + ($scope.editMode ? 'EDIT' : 'NEW'));
                        $state.go('appsoup.admin.appAttributes', {appId: appId, module: 'product'});
                    } else if (data.error) {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error(data.error);
                        }
                    }
                }).finally(function () {
                    $scope.isLoading = false;
                });
            }
        };


        $scope.cancel = function () {
            $state.go('appsoup.admin.appAttributes', {appId: appId, module: 'product'});
        };

        $scope.inputErrors = {
            'key': [{error: 'pattern', msg: 'MODULES.ATTRIBUTES.FORM_ERROR.KEY_FORMAT'}, {
                error: 'required',
                msg: 'MODULES.ATTRIBUTES.FORM_ERROR.KEY'
            }],
            'type': [{error: 'required', msg: 'MODULES.ATTRIBUTES.FORM_ERROR.TYPE'}],
            'label': [{error: 'required', msg: 'MODULES.ATTRIBUTES.FORM_ERROR.LABEL'}]
        };

    }]);
    /**
     * @ngdoc controller
     * @name adminModule.appsControllers.controller:AppCommunicationPushController
     * @description
     * Controller For Specific Application Communication Push
     */
    appsControllers.controller('AppCommunicationPushController', ['$scope', '$http', '$rootScope', '$state', '$modal', '$stateParams', 'growl', 'Page', 'App', function ($scope, $http, $rootScope, $state, $modal, $stateParams, growl, Page, App) {
        var appId = $stateParams.appId;

        $scope.upload = undefined;
        $scope.fileUploaded = false;
        $scope.app = {};
        $scope.app.type_notification = true;

        App.get(appId)
            .then(function (response) {
                if (angular.isDefined(response)) {
                    var data = response.data;
                    $scope.app = data.application;
                    $scope.app.password = '';

                    if (!angular.isUndefinedNullOrEmpty($scope.app.apple_certificate)) {
                        $scope.fileUploaded = true;
                    }

                    $scope.editMode = true;
                }
            });

        $scope.saveApp = function () {
            $scope.$broadcast('show-errors-check-validity');
            if ($scope.appForm.$valid) {
                $scope.isLoading = true;
                App.save($scope.app, $scope.editMode, $scope.upload)
                    .then(function (response) {
                        var data = response.data;
                        if (data.success) {
                            growl.success('MODULES.APPS.SUCCESS.' + ($scope.editMode ? 'EDIT' : 'NEW'));
                            $state.go('appsoup.admin.apps');
                        } else if (data.error) {
                            if (typeof data.error === 'object') {
                                $scope.formErrors = data.error;
                            } else {
                                growl.error(data.error);
                            }
                        }
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                    });
            }
        };

        $scope.cancel = function () {
            $state.go('appsoup.admin.apps');
        };

        $scope.uploadSuccess = function (file) {
            $scope.upload = file;
            $scope.fileUploaded = true;
            $scope.fileError = false;
            $scope.$apply();
        };

        $scope.removeFile = function () {
            $scope.upload = undefined;
            $scope.fileUploaded = false;
        };

        $scope.inputErrors = {
            'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}],
            'id': [{type: '$invalid', msg: 'ERROR.REQUIRE.ID'}],
            'email': [{error: 'required', msg: 'ERROR.REQUIRE.EMAIL'}, {error: 'email', msg: 'ERROR.INVALID_EMAIL'}]
        };

    }]);

    /**
     * @ngdoc controller
     * @name adminModule.appsControllers.controller:AppPlacementTypes
     * @description
     * Controller for specific Application Placement Types
     */
    appsControllers.controller('AppPlacementTypesController', [
        "$scope",
        "$http",
        "$rootScope",
        "$state",
        "$modal",
        "$stateParams",
        "growl",
        "Page",
        "App",
        "Permissions",
        function ($scope, $http, $rootScope, $state, $modal, $stateParams, growl, Page, App, Permissions) {
            var appId = $stateParams.appId;
            $scope.writeAccess = Permissions.hasWriteAccess('application');
            $scope.isLoadingList = true;

            App.get(appId)
                .then(function (response) {
                    if (angular.isDefined(response)) {
                        var data = response.data;
                        $scope.app = data.application;
                        if (angular.isDefinedNotNull($scope.app.placement_types)) {
                            $scope.placement_types = $scope.app.placement_types;
                        } else {
                            $scope.placement_types = [];
                        }
                        $scope.app.password = '';
                        $scope.editMode = true;
                    }
                })
                .finally(function () {
                    $scope.isLoadingList = false;
                });

            $scope.saveApp = function () {
                $scope.$broadcast('show-errors-check-validity');
                if ($scope.appForm.$valid) {
                    $scope.isLoading = true;
                    $scope.app.placement_types = angular.copy($scope.placement_types);
                    App.save($scope.app, $scope.editMode)
                        .then(function (response) {
                            var data = response.data;
                            if (data.success) {
                                growl.success('MODULES.APPS.SUCCESS.' + ($scope.editMode ? 'EDIT' : 'NEW'));
                                $state.go('appsoup.admin.apps');
                            } else if (data.error) {
                                if (typeof data.error === 'object') {
                                    $scope.formErrors = data.error;
                                } else {
                                    growl.error(data.error);
                                }
                            }
                        })
                        .finally(function () {
                            $scope.isLoading = false;
                        });
                }
            };
            $scope.newPlacement = function () {
                const modalInstance = $modal.open({
                    templateUrl: 'views/admin/apps/components/modal/placement_type.tpl.html',
                    controller: 'AppModalPlacementTypeController',
                    resolve: {
                        placement_type: function () {
                            return {};
                        }
                    }
                });
                modalInstance.result.then(function (data) {
                    if ($scope.placement_types.length > 0) {
                        $scope.maxPlacementType = Math.max.apply(Math, $scope.placement_types.map(function (item) {
                            return item.key;
                        }));
                        $scope.max = $scope.maxPlacementType + 1;
                    } else {
                        $scope.max = 0;
                    }

                    data.key = $scope.max;
                    $scope.placement_types.push(data);
                    growl.success('GROWL.SUCCESS.PLACEMENT.CREATED');
                }).catch(() => {});
            };

            $scope.editPlacement = function (placement_type) {
                const modalInstance = $modal.open({
                    templateUrl: 'views/admin/apps/components/modal/placement_type.tpl.html',
                    controller: 'AppModalPlacementTypeController',
                    resolve: {
                        placement_type: function () {
                            return placement_type;
                        }
                    }
                });
                modalInstance.result.then(function (data) {
                    angular.forEach($scope.placement_types, function (element, k) {
                        if (element.key == data.key) {
                            $scope.placement_types[k] = data;
                        }

                    });
                    growl.success('GROWL.SUCCESS.PLACEMENT.EDITED');
                }).catch(() => {});
            };

            $scope.deletePlacement = function (placement_type, index) {
                $scope.placement_types.splice(index, 1);
            };

            $scope.remove = function ($event) {
                $event.stopImmediatePropagation();
            };

            $scope.cancel = function () {
                $state.go('appsoup.admin.apps');
            };
        }
    ]);

    /**
     * @ngdoc controller
     * @name adminModule.appsControllers.controller:AppModalPlacementTypeController
     * @description
     * Controller for specific Application Placement Type
     */
    appsControllers.controller('AppModalPlacementTypeController', [
        "$scope",
        "$modalInstance",
        "growl",
        "placement_type",
        function ($scope, $modalInstance, growl, placement_type) {
            $scope.placement_type = {};

            if (placement_type) {
                $scope.placement_type = placement_type;
            }

            $scope.ok = function () {
                $scope.$broadcast('show-errors-check-validity');
                if ($scope.appForm.$valid) {
                    $modalInstance.close($scope.placement_type);
                    $modalInstance.close();
                } else {
                    growl.error('GROWL.ERROR.REQUIRE.ALL');
                }
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.inputErrors = {
                'value': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
                'label': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}]
            };
        }
    ]);

})();

export default appsControllers;
